var _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRuRussianFederationthe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3445_26540",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 44,
    height: 44
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.9208,
    cy: 21.7841,
    r: 21.7841,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3445_26540)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.136719,
    y: 43.5681,
    width: 14.5227,
    height: 43.5682,
    transform: "rotate(-90 0.136719 43.5681)",
    fill: "#DD2033"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.136719,
    y: 29.0454,
    width: 14.5227,
    height: 43.5682,
    transform: "rotate(-90 0.136719 29.0454)",
    fill: "#004692"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.136719,
    y: 14.5227,
    width: 14.5227,
    height: 43.5682,
    transform: "rotate(-90 0.136719 14.5227)",
    fill: "#F5F7F8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuRussianFederationthe);
export default __webpack_public_path__ + "static/media/RU Russian Federation (the).cd558e7132d1633f4548abe4319c66ea.svg";
export { ForwardRef as ReactComponent };